import { render, staticRenderFns } from "./ContactsAutocomplete.vue?vue&type=template&id=b1dabbbc"
import script from "./ContactsAutocomplete.vue?vue&type=script&lang=js"
export * from "./ContactsAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports